import moment from "moment";
import { Meeting } from "@platform/types/platform.types";

export type Args = {
  meetings: Meeting[];
  outputFileName?: string;
  eventTitle: string;
  eventDescription?: string;
  eventUrl?: string;
};

export function generateICSLinkForMeetingArray({
  meetings,
  outputFileName,
  eventTitle,
  eventDescription,
  eventUrl,
}: Args) {
  let icsContent = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Pollinator//Pollinator Platform//EN",
    "CALSCALE:GREGORIAN",
  ];

  meetings.forEach((meeting) => {
    const startTime =
      moment.utc(meeting.start_time).format("YYYYMMDDTHHmmss") + "Z";
    const endTime =
      moment.utc(meeting.end_time).format("YYYYMMDDTHHmmss") + "Z";
    const now = moment.utc().format("YYYYMMDDTHHmmss") + "Z";

    icsContent.push(
      "BEGIN:VEVENT",
      `DTSTART:${startTime}`,
      `DTEND:${endTime}`,
      `DTSTAMP:${now}`,
      `UID:meeting-${meeting.start_time}@pollinator.coop`,
      `SUMMARY:${eventTitle}`,
      `DESCRIPTION:${eventDescription}`,
      `URL:${eventUrl}`,
      "STATUS:CONFIRMED",
      "END:VEVENT"
    );
  });

  icsContent.push("END:VCALENDAR");

  // Create and download the file
  const blob = new Blob([icsContent.join("\r\n")], {
    type: "text/calendar;charset=utf-8",
  });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");

  link.href = url;

  link.download = outputFileName || "pollinator-meetings.ics";

  return { link, url };
}

export default generateICSLinkForMeetingArray;
